import store from '@speechki-frontend/core/store/store';
import guestAccess from './store/guestAccess';

export default function (data) {
    if (!store.hasModule('guestAccess')) {
        store.registerModule('guestAccess', guestAccess);
    }

    store.dispatch('guestAccess/createGuestAccessState', data);
}
